// EDITOR
export const EDITOR_SECURE_FILES_MODAL_HEADER = 'Vælg sikker fil';
